import { push, replace as replaceRoute } from "connected-react-router";

export function redirect(route) {
  // Pass the path as a string so history parses pathname/search/hash itself.
  // Passing `{ pathname: route }` instead leaves any "?query" buried in
  // pathname (history won't split an object's fields), so the location matches
  // no <Route> and the screen goes blank.
  return (dispatch) => dispatch(push(route));
}

export function replace(route) {
  // Overwrites the current history entry instead of adding one, so Back does
  // not return to the address being replaced.
  return (dispatch) => dispatch(replaceRoute(route));
}
